import { Link } from 'react-router-dom'
import Footer from '../components/footer'
import topImgPc from "../assets/images/topimage_pc_1.png"
import topImgPcC from "../assets/images/topimage_pc_neko_c.png"
import topImgSp from "../assets/images/topimage_sp_1.png"
import topImgSpC from "../assets/images/topimage_sp_neko_c.png"
import btnStart from "../assets/images/btn_start.png"
import Facebook from "../assets/images/facebook.png"
import Twitter from "../assets/images/twitter.png"
import {FacebookShareButton, TwitterShareButton } from 'react-share';


const Main = () => {

  const localStorageClear = () => {
    localStorage.clear();
  }

  return (
    <div>
      <div className="top-img p-relative">
        <img alt="main_img" src={ topImgPc } className="pc"/>
        <img alt="main_img" src={ topImgPcC } className="pc topimage_pc_neko anime_poyoyon"/>
        <img alt="main_img" src={ topImgSp } className="sp"/>
        <img alt="main_img" src={ topImgSpC } className="sp topimage_sp_neko anime_zoomin"/>
        <Link to="/nanineko/impression"  className="sp"><button className="p-absolute"><img src={ btnStart } /></button></Link>
      </div>
      <div className="start_wrapper">
        <Link to="/nanineko/impression"  className="pc start"><button onClick={ localStorageClear }><img src={ btnStart } /></button></Link>
      </div>
      <div className="top-textarea">
        <h2>何ネコ診断って？</h2>
        <p>〈うちの子〉がどんな子かわかる！？<br />……かもしれない「何ねこ？」は、知っているようで知らなかった愛猫さんの素顔を、動物行動学に基づいた分析でチェックできるアプリです。<br />ふたりめの猫さんを飼いたい人、保護猫さんを譲渡したい人や団体さんも活用してみてください。</p>
        <Link to="../nanineko/about" className="text-link" onClick={ localStorageClear }>→このアプリについてもっと詳しく</Link>
      </div><div className="top-textarea">
        <h2>アプリ監修</h2>
        <h3>入交 眞巳</h3>
        <p>日本獣医畜産大学（現日本獣医生命科学大学）卒業。都内の動物病院勤務後、米国パデュー大学で学位取得、ジョージア大学付属獣医教育病院獣医行動診療科レジデント課程を修了。米国獣医行動学専門医の資格を有する。北里大学獣医学部講師、日本獣医生命科学大学獣医学部講師を経て、どうぶつの総合病院行動診療科主任、東京農工大学特任講師を務める。現在も、各地の獣医科大学の非常勤講師として教鞭をとる。著書に『猫が幸せならばそれでいい』（小学館）。</p>
      </div>
      <div className="sns">
        <p>この診断をシェアする！</p>
        <div className="flex-center">
        <FacebookShareButton url={"https://suama-catscafe.com/nanineko/"} quote={`あなたの愛猫さんは何ねこ？ #うちの子何猫ねこ`}>
          <img alt="facebook" src={ Facebook } />
        </FacebookShareButton>
        <TwitterShareButton url={"https://suama-catscafe.com/nanineko/"} title={`あなたの愛猫さんは何ねこ？  #うちの子何猫ねこ`}>
          <img alt="twitter" src={ Twitter } />
        </TwitterShareButton>
        </div>
      </div>
      <Footer />
    </div>
  )
}
  
  export default Main